module.exports = __webpack_public_path__ + "static/media/bell.cf04af27.png";